// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2sy_c","importantInfo":"styles_importantInfo__34la7"};